var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showCount)?_c('div',{staticClass:"nature-time-count-ani"}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }